var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBackgroundProfileThreeMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 632,
    height: 232,
    viewBox: "0 0 632 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_208_19640)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_208_19640)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -78,
    y: -22,
    width: 728,
    height: 455
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(18px)",
      clipPath: "url(#bgblur_1_208_19640_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 36
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 15H598C606.284 15 613 21.7157 613 30V157H15V30C15 21.7157 21.7157 15 30 15Z",
    stroke: "#A8F0E7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_208_19640)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M614 397H-42V14H614V397Z",
    fill: "url(#paint0_linear_208_19640)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M614 242.742H274.085V76.7976L414.399 -4.31787H614V242.742Z",
    fill: "url(#paint1_linear_208_19640)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M614 242.742H372.886V133.914L521.548 47.9739L614 101.42V242.742Z",
    fill: "url(#paint2_linear_208_19640)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M521.548 112.965L567.774 139.689L614 166.412V219.856V242.742H429.1V219.856V166.412L475.325 139.689L521.548 112.965Z",
    fill: "#1EAE9B"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_208_19640",
    x: 0,
    y: 0,
    width: 632,
    height: 232,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_208_19640"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_208_19640",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_208_19640_clip_path",
    transform: "translate(78 22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 15H598C606.284 15 613 21.7157 613 30V157H15V30C15 21.7157 21.7157 15 30 15Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_208_19640",
    x1: 646.415,
    y1: -220.465,
    x2: -75.7471,
    y2: 248.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EAE9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8F0E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_208_19640",
    x1: 486.374,
    y1: -20.6699,
    x2: 287.949,
    y2: 359.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EAE9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8F0E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_208_19640",
    x1: 493.443,
    y1: -42.0632,
    x2: 493.443,
    y2: 242.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8F0E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1EAE9B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_208_19640"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 30C14 21.1634 21.1634 14 30 14H598C606.837 14 614 21.1634 614 30V214H14V30Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_208_19640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 656,
    height: 383,
    fill: "white",
    transform: "translate(-42 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBackgroundProfileThreeMobile);
export default __webpack_public_path__ + "static/media/ic-background-profile-three-mobile.37dc98e5a6d680c722a2cde9508fd1c6.svg";
export { ForwardRef as ReactComponent };